/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchContactOperation,
    BatchContactOperationFromJSON,
    BatchContactOperationToJSON,
    Contact,
    ContactFromJSON,
    ContactToJSON,
    ContactAccountBalance,
    ContactAccountBalanceFromJSON,
    ContactAccountBalanceToJSON,
    ContactBalanceTransaction,
    ContactBalanceTransactionFromJSON,
    ContactBalanceTransactionToJSON,
    ContactBalanceTransactionCreateParams,
    ContactBalanceTransactionCreateParamsFromJSON,
    ContactBalanceTransactionCreateParamsToJSON,
    ContactBalanceTransactionList,
    ContactBalanceTransactionListFromJSON,
    ContactBalanceTransactionListToJSON,
    ContactBalanceTransactionUpdateParams,
    ContactBalanceTransactionUpdateParamsFromJSON,
    ContactBalanceTransactionUpdateParamsToJSON,
    ContactCreateParams,
    ContactCreateParamsFromJSON,
    ContactCreateParamsToJSON,
    ContactExpandableType,
    ContactExpandableTypeFromJSON,
    ContactExpandableTypeToJSON,
    ContactList,
    ContactListFromJSON,
    ContactListToJSON,
    ContactMarketingUnsubscribeParams,
    ContactMarketingUnsubscribeParamsFromJSON,
    ContactMarketingUnsubscribeParamsToJSON,
    CustomerPaymentMethodCreateParams,
    CustomerPaymentMethodCreateParamsFromJSON,
    CustomerPaymentMethodCreateParamsToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FeedbackRating,
    FeedbackRatingFromJSON,
    FeedbackRatingToJSON,
    FileAccess,
    FileAccessFromJSON,
    FileAccessToJSON,
    FilePurpose,
    FilePurposeFromJSON,
    FilePurposeToJSON,
    Gender,
    GenderFromJSON,
    GenderToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    MappedField,
    MappedFieldFromJSON,
    MappedFieldToJSON,
    PaymentSource,
    PaymentSourceFromJSON,
    PaymentSourceToJSON,
    PaymentSourceList,
    PaymentSourceListFromJSON,
    PaymentSourceListToJSON,
    PropertyList,
    PropertyListFromJSON,
    PropertyListToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface AttachContactPaymentMethodRequest {
    program_id: string;
    contact_id: string;
    source_id: string;
    CustomerPaymentMethodCreateParams: CustomerPaymentMethodCreateParams;
}

export interface CreateBulkContactRequest {
    program_id: string;
    ContactCreateParams: Array<ContactCreateParams>;
}

export interface CreateContactRequest {
    program_id: string;
    ContactCreateParams: ContactCreateParams;
}

export interface CreateContactAccountBalanceRequest {
    program_id: string;
    contact_id: string;
    ContactBalanceTransactionCreateParams: ContactBalanceTransactionCreateParams;
}

export interface DetachContactPaymentMethodRequest {
    program_id: string;
    contact_id: string;
    source_id: string;
}

export interface FindBalanceContactAccountBalanceRequest {
    program_id: string;
    contact_id: string;
}

export interface FindContactAccountBalancesRequest {
    program_id: string;
    contact_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindContactPaymentMethodsRequest {
    program_id: string;
    contact_id: string;
}

export interface FindContactsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    email?: string;
    has_account?: boolean;
    is_archived?: boolean;
    is_subscribed?: boolean;
    expand?: Array<ContactExpandableType>;
    feedback_rating?: Array<FeedbackRating>;
    attendee_gender?: Array<Gender>;
    attendee_birthday?: Date;
    attendee_age_lt?: number;
    attendee_age_gt?: number;
    attendee_age_lte?: number;
    attendee_age_gte?: number;
    attendee_date_of_birth_lt?: Date;
    attendee_date_of_birth_gt?: Date;
    attendee_date_of_birth_lte?: Date;
    attendee_date_of_birth_gte?: Date;
    amount_order_total_lt?: number;
    amount_order_total_gt?: number;
    amount_order_total_lte?: number;
    amount_order_total_gte?: number;
    amount_refunded_lt?: number;
    amount_refunded_gt?: number;
    amount_refunded_lte?: number;
    amount_refunded_gte?: number;
    num_payments_lt?: number;
    num_payments_gt?: number;
    num_payments_lte?: number;
    num_payments_gte?: number;
    num_memberships_lt?: number;
    num_memberships_gt?: number;
    num_memberships_lte?: number;
    num_memberships_gte?: number;
    num_registrations_lt?: number;
    num_registrations_gt?: number;
    num_registrations_lte?: number;
    num_registrations_gte?: number;
    num_relations_lt?: number;
    num_relations_gt?: number;
    num_relations_lte?: number;
    num_relations_gte?: number;
    first_purchase_lt?: Date;
    first_purchase_gt?: Date;
    first_purchase_lte?: Date;
    first_purchase_gte?: Date;
    last_purchase_lt?: Date;
    last_purchase_gt?: Date;
    last_purchase_lte?: Date;
    last_purchase_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface FindOneContactRequest {
    program_id: string;
    contact_id: string;
    expand?: Array<ContactExpandableType>;
}

export interface FindTransactionContactAccountBalanceRequest {
    program_id: string;
    contact_id: string;
    transaction_id: string;
}

export interface GetPropertiesContactRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
}

export interface GetPropertyValuesContactRequest {
    program_id: string;
    property_key: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
}

export interface InviteContactRequest {
    program_id: string;
    contact_id: string;
}

export interface ParseFileContactRequest {
    program_id: string;
    purpose: FilePurpose;
    file: Blob;
    access?: FileAccess;
}

export interface SetDefaultContactPaymentMethodRequest {
    program_id: string;
    contact_id: string;
    source_id: string;
}

export interface SubscribeContactMarketingRequest {
    program_id: string;
    contact_id: string;
}

export interface UnsubscribeContactMarketingRequest {
    program_id: string;
    contact_id: string;
    ContactMarketingUnsubscribeParams: ContactMarketingUnsubscribeParams;
}

export interface UpdateContactRequest {
    program_id: string;
    contact_id: string;
    Contact: Contact;
}

export interface UpdateContactAccountBalanceRequest {
    program_id: string;
    contact_id: string;
    transaction_id: string;
    ContactBalanceTransactionUpdateParams: ContactBalanceTransactionUpdateParams;
}

/**
 * 
 */
export class ContactsApi extends runtime.BaseAPI {

    /**
     * Attach source to customer
     */
    async attachContactPaymentMethodRaw(requestParameters: AttachContactPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentSource>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling attachContactPaymentMethod.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling attachContactPaymentMethod.');
        }

        if (requestParameters.source_id === null || requestParameters.source_id === undefined) {
            throw new runtime.RequiredError('source_id','Required parameter requestParameters.source_id was null or undefined when calling attachContactPaymentMethod.');
        }

        if (requestParameters.CustomerPaymentMethodCreateParams === null || requestParameters.CustomerPaymentMethodCreateParams === undefined) {
            throw new runtime.RequiredError('CustomerPaymentMethodCreateParams','Required parameter requestParameters.CustomerPaymentMethodCreateParams was null or undefined when calling attachContactPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/payment_methods/{source_id}/attach`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.source_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerPaymentMethodCreateParamsToJSON(requestParameters.CustomerPaymentMethodCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentSourceFromJSON(jsonValue));
    }

    /**
     * Attach source to customer
     */
    async attachContactPaymentMethod(requestParameters: AttachContactPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentSource> {
        const response = await this.attachContactPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create contacts in bulk
     */
    async createBulkContactRaw(requestParameters: CreateBulkContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchContactOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createBulkContact.');
        }

        if (requestParameters.ContactCreateParams === null || requestParameters.ContactCreateParams === undefined) {
            throw new runtime.RequiredError('ContactCreateParams','Required parameter requestParameters.ContactCreateParams was null or undefined when calling createBulkContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/bulk`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.ContactCreateParams.map(ContactCreateParamsToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchContactOperationFromJSON(jsonValue));
    }

    /**
     * Create contacts in bulk
     */
    async createBulkContact(requestParameters: CreateBulkContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchContactOperation> {
        const response = await this.createBulkContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create contact
     */
    async createContactRaw(requestParameters: CreateContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createContact.');
        }

        if (requestParameters.ContactCreateParams === null || requestParameters.ContactCreateParams === undefined) {
            throw new runtime.RequiredError('ContactCreateParams','Required parameter requestParameters.ContactCreateParams was null or undefined when calling createContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactCreateParamsToJSON(requestParameters.ContactCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Create contact
     */
    async createContact(requestParameters: CreateContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Contact> {
        const response = await this.createContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create balance transaction
     */
    async createContactAccountBalanceRaw(requestParameters: CreateContactAccountBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ContactBalanceTransaction>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createContactAccountBalance.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling createContactAccountBalance.');
        }

        if (requestParameters.ContactBalanceTransactionCreateParams === null || requestParameters.ContactBalanceTransactionCreateParams === undefined) {
            throw new runtime.RequiredError('ContactBalanceTransactionCreateParams','Required parameter requestParameters.ContactBalanceTransactionCreateParams was null or undefined when calling createContactAccountBalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/transactions`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactBalanceTransactionCreateParamsToJSON(requestParameters.ContactBalanceTransactionCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactBalanceTransactionFromJSON(jsonValue));
    }

    /**
     * Create balance transaction
     */
    async createContactAccountBalance(requestParameters: CreateContactAccountBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ContactBalanceTransaction> {
        const response = await this.createContactAccountBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Detach source to customer
     */
    async detachContactPaymentMethodRaw(requestParameters: DetachContactPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling detachContactPaymentMethod.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling detachContactPaymentMethod.');
        }

        if (requestParameters.source_id === null || requestParameters.source_id === undefined) {
            throw new runtime.RequiredError('source_id','Required parameter requestParameters.source_id was null or undefined when calling detachContactPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/payment_methods/{source_id}/detach`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.source_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Detach source to customer
     */
    async detachContactPaymentMethod(requestParameters: DetachContactPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.detachContactPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find contact\'s account balance by id
     */
    async findBalanceContactAccountBalanceRaw(requestParameters: FindBalanceContactAccountBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ContactAccountBalance>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findBalanceContactAccountBalance.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling findBalanceContactAccountBalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/balance`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactAccountBalanceFromJSON(jsonValue));
    }

    /**
     * Find contact\'s account balance by id
     */
    async findBalanceContactAccountBalance(requestParameters: FindBalanceContactAccountBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ContactAccountBalance> {
        const response = await this.findBalanceContactAccountBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all contact\'s balance transactions
     */
    async findContactAccountBalancesRaw(requestParameters: FindContactAccountBalancesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ContactBalanceTransactionList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findContactAccountBalances.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling findContactAccountBalances.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/transactions`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactBalanceTransactionListFromJSON(jsonValue));
    }

    /**
     * List all contact\'s balance transactions
     */
    async findContactAccountBalances(requestParameters: FindContactAccountBalancesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ContactBalanceTransactionList> {
        const response = await this.findContactAccountBalancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all payment methods
     */
    async findContactPaymentMethodsRaw(requestParameters: FindContactPaymentMethodsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentSourceList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findContactPaymentMethods.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling findContactPaymentMethods.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/payment_methods`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentSourceListFromJSON(jsonValue));
    }

    /**
     * List all payment methods
     */
    async findContactPaymentMethods(requestParameters: FindContactPaymentMethodsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentSourceList> {
        const response = await this.findContactPaymentMethodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all contacts
     */
    async findContactsRaw(requestParameters: FindContactsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ContactList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findContacts.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.is_subscribed !== undefined) {
            queryParameters['is_subscribed'] = requestParameters.is_subscribed;
        }

        if (requestParameters.expand) {
            queryParameters['expand'] = requestParameters.expand;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.attendee_birthday !== undefined) {
            queryParameters['attendee_birthday'] = (requestParameters.attendee_birthday as any).toISOString();
        }

        if (requestParameters.attendee_age_lt !== undefined) {
            queryParameters['attendee_age_lt'] = requestParameters.attendee_age_lt;
        }

        if (requestParameters.attendee_age_gt !== undefined) {
            queryParameters['attendee_age_gt'] = requestParameters.attendee_age_gt;
        }

        if (requestParameters.attendee_age_lte !== undefined) {
            queryParameters['attendee_age_lte'] = requestParameters.attendee_age_lte;
        }

        if (requestParameters.attendee_age_gte !== undefined) {
            queryParameters['attendee_age_gte'] = requestParameters.attendee_age_gte;
        }

        if (requestParameters.attendee_date_of_birth_lt !== undefined) {
            queryParameters['attendee_date_of_birth_lt'] = (requestParameters.attendee_date_of_birth_lt as any).toISOString();
        }

        if (requestParameters.attendee_date_of_birth_gt !== undefined) {
            queryParameters['attendee_date_of_birth_gt'] = (requestParameters.attendee_date_of_birth_gt as any).toISOString();
        }

        if (requestParameters.attendee_date_of_birth_lte !== undefined) {
            queryParameters['attendee_date_of_birth_lte'] = (requestParameters.attendee_date_of_birth_lte as any).toISOString();
        }

        if (requestParameters.attendee_date_of_birth_gte !== undefined) {
            queryParameters['attendee_date_of_birth_gte'] = (requestParameters.attendee_date_of_birth_gte as any).toISOString();
        }

        if (requestParameters.amount_order_total_lt !== undefined) {
            queryParameters['amount_order_total_lt'] = requestParameters.amount_order_total_lt;
        }

        if (requestParameters.amount_order_total_gt !== undefined) {
            queryParameters['amount_order_total_gt'] = requestParameters.amount_order_total_gt;
        }

        if (requestParameters.amount_order_total_lte !== undefined) {
            queryParameters['amount_order_total_lte'] = requestParameters.amount_order_total_lte;
        }

        if (requestParameters.amount_order_total_gte !== undefined) {
            queryParameters['amount_order_total_gte'] = requestParameters.amount_order_total_gte;
        }

        if (requestParameters.amount_refunded_lt !== undefined) {
            queryParameters['amount_refunded_lt'] = requestParameters.amount_refunded_lt;
        }

        if (requestParameters.amount_refunded_gt !== undefined) {
            queryParameters['amount_refunded_gt'] = requestParameters.amount_refunded_gt;
        }

        if (requestParameters.amount_refunded_lte !== undefined) {
            queryParameters['amount_refunded_lte'] = requestParameters.amount_refunded_lte;
        }

        if (requestParameters.amount_refunded_gte !== undefined) {
            queryParameters['amount_refunded_gte'] = requestParameters.amount_refunded_gte;
        }

        if (requestParameters.num_payments_lt !== undefined) {
            queryParameters['num_payments_lt'] = requestParameters.num_payments_lt;
        }

        if (requestParameters.num_payments_gt !== undefined) {
            queryParameters['num_payments_gt'] = requestParameters.num_payments_gt;
        }

        if (requestParameters.num_payments_lte !== undefined) {
            queryParameters['num_payments_lte'] = requestParameters.num_payments_lte;
        }

        if (requestParameters.num_payments_gte !== undefined) {
            queryParameters['num_payments_gte'] = requestParameters.num_payments_gte;
        }

        if (requestParameters.num_memberships_lt !== undefined) {
            queryParameters['num_memberships_lt'] = requestParameters.num_memberships_lt;
        }

        if (requestParameters.num_memberships_gt !== undefined) {
            queryParameters['num_memberships_gt'] = requestParameters.num_memberships_gt;
        }

        if (requestParameters.num_memberships_lte !== undefined) {
            queryParameters['num_memberships_lte'] = requestParameters.num_memberships_lte;
        }

        if (requestParameters.num_memberships_gte !== undefined) {
            queryParameters['num_memberships_gte'] = requestParameters.num_memberships_gte;
        }

        if (requestParameters.num_registrations_lt !== undefined) {
            queryParameters['num_registrations_lt'] = requestParameters.num_registrations_lt;
        }

        if (requestParameters.num_registrations_gt !== undefined) {
            queryParameters['num_registrations_gt'] = requestParameters.num_registrations_gt;
        }

        if (requestParameters.num_registrations_lte !== undefined) {
            queryParameters['num_registrations_lte'] = requestParameters.num_registrations_lte;
        }

        if (requestParameters.num_registrations_gte !== undefined) {
            queryParameters['num_registrations_gte'] = requestParameters.num_registrations_gte;
        }

        if (requestParameters.num_relations_lt !== undefined) {
            queryParameters['num_relations_lt'] = requestParameters.num_relations_lt;
        }

        if (requestParameters.num_relations_gt !== undefined) {
            queryParameters['num_relations_gt'] = requestParameters.num_relations_gt;
        }

        if (requestParameters.num_relations_lte !== undefined) {
            queryParameters['num_relations_lte'] = requestParameters.num_relations_lte;
        }

        if (requestParameters.num_relations_gte !== undefined) {
            queryParameters['num_relations_gte'] = requestParameters.num_relations_gte;
        }

        if (requestParameters.first_purchase_lt !== undefined) {
            queryParameters['first_purchase_lt'] = (requestParameters.first_purchase_lt as any).toISOString();
        }

        if (requestParameters.first_purchase_gt !== undefined) {
            queryParameters['first_purchase_gt'] = (requestParameters.first_purchase_gt as any).toISOString();
        }

        if (requestParameters.first_purchase_lte !== undefined) {
            queryParameters['first_purchase_lte'] = (requestParameters.first_purchase_lte as any).toISOString();
        }

        if (requestParameters.first_purchase_gte !== undefined) {
            queryParameters['first_purchase_gte'] = (requestParameters.first_purchase_gte as any).toISOString();
        }

        if (requestParameters.last_purchase_lt !== undefined) {
            queryParameters['last_purchase_lt'] = (requestParameters.last_purchase_lt as any).toISOString();
        }

        if (requestParameters.last_purchase_gt !== undefined) {
            queryParameters['last_purchase_gt'] = (requestParameters.last_purchase_gt as any).toISOString();
        }

        if (requestParameters.last_purchase_lte !== undefined) {
            queryParameters['last_purchase_lte'] = (requestParameters.last_purchase_lte as any).toISOString();
        }

        if (requestParameters.last_purchase_gte !== undefined) {
            queryParameters['last_purchase_gte'] = (requestParameters.last_purchase_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactListFromJSON(jsonValue));
    }

    /**
     * List all contacts
     */
    async findContacts(requestParameters: FindContactsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ContactList> {
        const response = await this.findContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find contact by id
     */
    async findOneContactRaw(requestParameters: FindOneContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneContact.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling findOneContact.');
        }

        const queryParameters: any = {};

        if (requestParameters.expand) {
            queryParameters['expand'] = requestParameters.expand;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Find contact by id
     */
    async findOneContact(requestParameters: FindOneContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Contact> {
        const response = await this.findOneContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find balance transaction by id
     */
    async findTransactionContactAccountBalanceRaw(requestParameters: FindTransactionContactAccountBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ContactBalanceTransaction>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findTransactionContactAccountBalance.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling findTransactionContactAccountBalance.');
        }

        if (requestParameters.transaction_id === null || requestParameters.transaction_id === undefined) {
            throw new runtime.RequiredError('transaction_id','Required parameter requestParameters.transaction_id was null or undefined when calling findTransactionContactAccountBalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/transactions/{transaction_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))).replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transaction_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactBalanceTransactionFromJSON(jsonValue));
    }

    /**
     * Find balance transaction by id
     */
    async findTransactionContactAccountBalance(requestParameters: FindTransactionContactAccountBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ContactBalanceTransaction> {
        const response = await this.findTransactionContactAccountBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all contact properties
     */
    async getPropertiesContactRaw(requestParameters: GetPropertiesContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PropertyList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling getPropertiesContact.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/properties`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyListFromJSON(jsonValue));
    }

    /**
     * List all contact properties
     */
    async getPropertiesContact(requestParameters: GetPropertiesContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PropertyList> {
        const response = await this.getPropertiesContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find contact property values by key
     */
    async getPropertyValuesContactRaw(requestParameters: GetPropertyValuesContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PropertyList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling getPropertyValuesContact.');
        }

        if (requestParameters.property_key === null || requestParameters.property_key === undefined) {
            throw new runtime.RequiredError('property_key','Required parameter requestParameters.property_key was null or undefined when calling getPropertyValuesContact.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/properties/{property_key}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"property_key"}}`, encodeURIComponent(String(requestParameters.property_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyListFromJSON(jsonValue));
    }

    /**
     * Find contact property values by key
     */
    async getPropertyValuesContact(requestParameters: GetPropertyValuesContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PropertyList> {
        const response = await this.getPropertyValuesContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send invite to contact
     */
    async inviteContactRaw(requestParameters: InviteContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling inviteContact.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling inviteContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/invite`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Send invite to contact
     */
    async inviteContact(requestParameters: InviteContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.inviteContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Parse csv/xlsx file and map to contact
     */
    async parseFileContactRaw(requestParameters: ParseFileContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<MappedField>>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling parseFileContact.');
        }

        if (requestParameters.purpose === null || requestParameters.purpose === undefined) {
            throw new runtime.RequiredError('purpose','Required parameter requestParameters.purpose was null or undefined when calling parseFileContact.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling parseFileContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.purpose !== undefined) {
            formParams.append('purpose', new Blob([JSON.stringify(FilePurposeToJSON(requestParameters.purpose))], { type: "application/json", }));
                    }

        if (requestParameters.access !== undefined) {
            formParams.append('access', new Blob([JSON.stringify(FileAccessToJSON(requestParameters.access))], { type: "application/json", }));
                    }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/parse`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MappedFieldFromJSON));
    }

    /**
     * Parse csv/xlsx file and map to contact
     */
    async parseFileContact(requestParameters: ParseFileContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<MappedField>> {
        const response = await this.parseFileContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set source as default for customer
     */
    async setDefaultContactPaymentMethodRaw(requestParameters: SetDefaultContactPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling setDefaultContactPaymentMethod.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling setDefaultContactPaymentMethod.');
        }

        if (requestParameters.source_id === null || requestParameters.source_id === undefined) {
            throw new runtime.RequiredError('source_id','Required parameter requestParameters.source_id was null or undefined when calling setDefaultContactPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/payment_methods/{source_id}/set_default`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.source_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Set source as default for customer
     */
    async setDefaultContactPaymentMethod(requestParameters: SetDefaultContactPaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.setDefaultContactPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe contact to program\'s notifications
     */
    async subscribeContactMarketingRaw(requestParameters: SubscribeContactMarketingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling subscribeContactMarketing.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling subscribeContactMarketing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/subscribe`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Subscribe contact to program\'s notifications
     */
    async subscribeContactMarketing(requestParameters: SubscribeContactMarketingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Contact> {
        const response = await this.subscribeContactMarketingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe contact to program\'s notifications
     */
    async unsubscribeContactMarketingRaw(requestParameters: UnsubscribeContactMarketingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling unsubscribeContactMarketing.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling unsubscribeContactMarketing.');
        }

        if (requestParameters.ContactMarketingUnsubscribeParams === null || requestParameters.ContactMarketingUnsubscribeParams === undefined) {
            throw new runtime.RequiredError('ContactMarketingUnsubscribeParams','Required parameter requestParameters.ContactMarketingUnsubscribeParams was null or undefined when calling unsubscribeContactMarketing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/unsubscribe`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactMarketingUnsubscribeParamsToJSON(requestParameters.ContactMarketingUnsubscribeParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Subscribe contact to program\'s notifications
     */
    async unsubscribeContactMarketing(requestParameters: UnsubscribeContactMarketingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Contact> {
        const response = await this.unsubscribeContactMarketingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update contact
     */
    async updateContactRaw(requestParameters: UpdateContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateContact.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling updateContact.');
        }

        if (requestParameters.Contact === null || requestParameters.Contact === undefined) {
            throw new runtime.RequiredError('Contact','Required parameter requestParameters.Contact was null or undefined when calling updateContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ContactToJSON(requestParameters.Contact),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Update contact
     */
    async updateContact(requestParameters: UpdateContactRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Contact> {
        const response = await this.updateContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update balance transaction by id
     */
    async updateContactAccountBalanceRaw(requestParameters: UpdateContactAccountBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ContactBalanceTransaction>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateContactAccountBalance.');
        }

        if (requestParameters.contact_id === null || requestParameters.contact_id === undefined) {
            throw new runtime.RequiredError('contact_id','Required parameter requestParameters.contact_id was null or undefined when calling updateContactAccountBalance.');
        }

        if (requestParameters.transaction_id === null || requestParameters.transaction_id === undefined) {
            throw new runtime.RequiredError('transaction_id','Required parameter requestParameters.transaction_id was null or undefined when calling updateContactAccountBalance.');
        }

        if (requestParameters.ContactBalanceTransactionUpdateParams === null || requestParameters.ContactBalanceTransactionUpdateParams === undefined) {
            throw new runtime.RequiredError('ContactBalanceTransactionUpdateParams','Required parameter requestParameters.ContactBalanceTransactionUpdateParams was null or undefined when calling updateContactAccountBalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/contacts/{contact_id}/transactions/{transaction_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contact_id))).replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters.transaction_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ContactBalanceTransactionUpdateParamsToJSON(requestParameters.ContactBalanceTransactionUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactBalanceTransactionFromJSON(jsonValue));
    }

    /**
     * Update balance transaction by id
     */
    async updateContactAccountBalance(requestParameters: UpdateContactAccountBalanceRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ContactBalanceTransaction> {
        const response = await this.updateContactAccountBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
